import $ from 'jquery';
import Isotope from 'isotope-layout';
import {Fancybox} from "@fancyapps/ui";

$(document).ready(function() {
    $('.galleryMasonryListing').each(function (index, element) {
        const listingSelector = '.listing';
        const listSelector = listingSelector + '__list';
        const itemSelector = listingSelector + '__item';
        const $listing = $(element);
        const $items = $listing.find(itemSelector);
        const $pagination = $listing.find(listingSelector + '__pagination');
        const step = 12;
        let visibleItemsNum = step;
        let matchCounter = 0;
        let isotope = null;

        function render() {
            isotope.arrange();
            $pagination.toggle( matchCounter > visibleItemsNum );
        }

        function showMoreItems() {
            visibleItemsNum = visibleItemsNum + step;
            matchCounter = 0;
            render();
        }

        function isotopeFilter() {
            matchCounter++;
            return matchCounter <= visibleItemsNum;
        }

        isotope = new Isotope(listSelector, {
            itemSelector: itemSelector,
            layoutMode: 'fitRows',
            filter: isotopeFilter,
            initLayout: false
        });

        $pagination.on('click', 'button', showMoreItems);

        render();
    });
});